import { BlurIcon } from '@rsos/base-assets/icons';
import { useDispatcherVideoContext } from '../../DispatcherVideoContext/useDispatcherVideoContext';
import { StyledButton } from './DispatcherControls.styles';

export const BlurButton = () => {
  const { isBlurred, toggleBlur, caller } = useDispatcherVideoContext();

  const tooltip = isBlurred ? 'Unblur' : 'Blur';

  return (
    <StyledButton title={tooltip} onClick={toggleBlur} disabled={!caller}>
      <BlurIcon />
    </StyledButton>
  );
};
